<template>
  <div class="weatherBox">
    <div class="WeatherPlaBox">{{townName}}</div>
    <div class="weatherinfoBox">
      <div class="weatherinfoBoxItem">
        <div class="weatherIconBox">
          <div class="WeatherIcon">
            <!-- <img src="https://moodsci.com/mimiproweb/img/run.png" alt style="height:50%" /> -->
          </div>
          <div class="TemBox">{{parseInt(todayWeatherInfo.temAvg)}}°</div>
        </div>
        <div class="weadesox">
          <!-- <div>星期五，十二月一日 12:00</div> -->
          <div>{{todayWeatherInfo.forecastTime}}</div>
          <div style="margin-top:5px">精彩的一天</div>
        </div>
      </div>
    </div>
    <div class="windBox">
      <div class="windBoxItem">
        <div style="text-align:center">
          <img src="https://moodsci.com/mimiproweb/img/wind.png" alt style="width:20px" />
        </div>
        <div style="font-size:25px">{{todayWeatherInfo.windSpeed}}m/s</div>
        <div style="font-size:12px">风力</div>
      </div>
      <div class="windBoxItem">
        <div style="text-align:center">
          <img src="https://moodsci.com/mimiproweb/img/rain.png" alt style="width:20px" />
        </div>
        <div style="font-size:25px">{{todayWeatherInfo.pre1h}}mm</div>
        <div style="font-size:12px">降水</div>
      </div>
      <div class="windBoxItem">
        <div style="text-align:center">
          <img src="https://moodsci.com/mimiproweb/img/rsu.png" alt style="width:20px" />
        </div>
        <div style="font-size:25px">{{todayWeatherInfo.rhuAvg}}%</div>
        <div style="font-size:12px">湿度</div>
      </div>
    </div>
    <div class="weaEchartBox">
      <div class="chooseWeatype">
        <div>逐时预报</div>
        <el-radio-group v-model="weatype" size="mini" @change="weatypeChange">
          <el-radio-button label="温度"></el-radio-button>
          <el-radio-button label="降水"></el-radio-button>
        </el-radio-group>
      </div>
      <div id="myChart2" style="height: 120px;width: 100%;"></div>
    </div>
    <div class="ForeBox">
      <div class="foreList">
        <div class="foreListItem" v-for="item in dayWeaListData">
          <div>{{setWeekData(item.forecastTime)}}</div>
          <div>
            <!-- <img src="https://moodsci.com/mimiproweb/img/晴.png" alt style="width:25px" /> -->
            <div>{{item.dayText}}</div>
          </div>
          <div style=" font-weight: 500;font-size:14px">{{item.temMin}}°~{{item.temMax}}°</div>
        </div>
      </div>
    </div>
    <div class="theayBox">
      <div class="theayBoxItem1">
        <!-- <div class="theayBoxChiItem">
          <div class="windInfoBox">
            <div>{{todayWeatherInfo.windAngleText}}</div>
            <div>{{todayWeatherInfo.windScale}}级</div>
          </div>
          <div class="iconBox">
            <img src="https://moodsci.com/mimiproweb/img/windFar.png" alt style="width:70%;" />
          </div>
        </div>-->
        <div class="theayBoxChiItem">
          <div class="windInfoBox2">
            <div>{{dayTodayData.sunrise}}日出</div>
            <div>{{dayTodayData.sunset}}日落</div>
          </div>
          <div class="iconBox">
            <img src="https://moodsci.com/mimiproweb/img/sunup.png" alt style="width:70%;" />
          </div>
        </div>
      </div>
      <div class="theayBoxItem">
        <div class="desListBox">
          <div class="desListItem">
            <div style=" color: #f1f1f1;font-size:14px">能见度</div>
            <div style=" color: white;font-size:18px">{{dayTodayData.vis}}</div>
          </div>
          <div class="desListItem">
            <div style=" color: #f1f1f1;font-size:14px">紫外线</div>
            <div style=" color: white;font-size:18px">{{ dayTodayData.uvIndex}}级</div>
          </div>
          <div class="desListItem">
            <div style=" color: #f1f1f1;font-size:14px">气压</div>
            <div style=" color: white;font-size:18px">{{dayTodayData.presSure}}hPa</div>
          </div>
          <!-- <div class="desListItem">
            <div style=" color: #f1f1f1;font-size:14px"></div>
            <div style=" color: white;font-size:18px">61%</div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import location from "../../uilts/get";

export default {
  data() {
    return {
      weatype: "温度",
      todayWeatherInfo: {},
      weatherDataList: [],
      dayWeaListData: [],
      dayTodayData: {},
      lat: "",
      lon: "",
      townName: ""
    };
  },
  mounted() {
    this.getData();
    // this.getData2();
    this.getLocation();
  },
  methods: {
    getPlaceName() {
      this.$axios({
        method: "get",
        url: `https://restapi.amap.com/v3/geocode/regeo?output=json&location=${this.lon},${this.lat}&key=4f4ab4fa2d15c8100c57cba218e9d31c&radius=1000&extensions=base`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        // console.log(res.data.regeocode.addressComponent.township);
        this.townName = res.data.regeocode.addressComponent.township;
        this.getWetherData();
      });
    },
    getLocation() {
      let t = this;
      // let geolocation = location.initMap("map-container"); // 定位
      // AMap.event.addListener(geolocation, "complete", result => {
      //   console.log(result);
      // });
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            // alert("经度：" + position.coords.latitude);
            t.lat = position.coords.latitude;
            // alert("纬度：" + position.coords.longitude);
            t.lon = position.coords.longitude;
            t.getPlaceName();
            // alert(position);
            // console.log(position);
          },
          function(error) {
            t.getData2();
            switch (error.code) {
              case error.PERMISSION_DENIED:
                alert("用户拒绝对获取地理位置的请求。");
                break;
              case error.POSITION_UNAVAILABLE:
                alert("位置信息是不可用的。");
                break;
              case error.TIMEOUT:
                alert("请求用户地理位置超时。");
                break;
              case error.UNKNOWN_ERROR:
                alert("未知错误。");
                break;
            }
          },
          { enableHighAcuracy: false }
        );
      } else {
        alert("Geolocation is not supported by this browser.");
        t.getData2();
      }
    },
    setWeekData(data) {
      //  moment(data, "YYYY-MM-DD HH:mm:dd").format("HH:mm")
      let week = moment(data, "YYYY-MM-DD HH:mm:dd").day();
      switch (week) {
        case 1:
          return "周一";
        case 2:
          return "周二";
        case 3:
          return "周三";
        case 4:
          return "周四";
        case 5:
          return "周五";
        case 6:
          return "周六";
        case 0:
          return "周日";
      }

      // return;
    },
    weatypeChange() {
      this.showEcharts();
    },
    getData() {
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/ForecastDayService/queryNewForecastDayList`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.dayWeaListData = res.data.data;
        // console.log(this.dayWeaListData);
        this.dayTodayData = this.dayWeaListData[0];
        console.log(this.dayTodayData);
      });
    },
    getWetherData() {
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/MusicService/querySPHCGridData?dateTime=${moment().format(
          "YYYY-MM-DD HH"
        )}:00:00&lat=${this.lat}&lon=${this.lon}`,
        //   url: `http://120.79.183.250:3093/InterfaceServices/MusicService/querySPHCGridData?dateTime=${moment().format(
        //   "YYYY-MM-DD HH"
        // )}:00:00&lat=${this.lat}&lon=${this.lon}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        console.log(res.data.data);
        this.todayWeatherInfo = res.data.data[0];
        this.weatherDataList = res.data.data.slice(1);
        console.log(this.todayWeatherInfo);
        this.showEcharts();
      });
    },
    getData2() {
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/ForecastHourService/queryNewForecastHourList`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        // console.log(res.data.data);
        this.todayWeatherInfo = res.data.data[0];
        this.weatherDataList = res.data.data.slice(1);
        console.log(this.todayWeatherInfo);
        this.showEcharts();
      });
    },
    showEcharts() {
      let myChart = this.$echarts.init(document.getElementById("myChart2"));
      // 绘制图表;
      let timeList = [];
      let dataList = [];
      if (this.weatype == "温度") {
        this.weatherDataList.map(item => {
          dataList.push(item.temAvg);

          timeList.push(
            moment(item.dateTime, "YYYY-MM-DD HH:mm:dd").format("HH:mm")
          );
          // dataList.push(item[this.$route.params.type]);
        });
      } else {
        this.weatherDataList.map(item => {
          dataList.push(item.pre1h);

          timeList.push(
            moment(item.dateTime, "YYYY-MM-DD HH:mm:dd").format("HH:mm")
          );
          // dataList.push(item[this.$route.params.type]);
        });
      }

      console.log(dataList);
      myChart.setOption({
        grid: {
          top: "20%",
          left: "0%",
          right: "5%",
          bottom: "5%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#42A0FD",
              width: 1
            }
          },
          data: timeList
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#42A0FD",
              width: 1
            }
          }
        },
        series: [
          {
            itemStyle: {
              normal: {
                color: "#42A0FD",
                lineStyle: {
                  color: "#42A0FD"
                },
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#42A0FD",
                    fontSize: 6
                  }
                }
              }
            },
            data: dataList,
            type: "line"
            // itemStyle: {
            //   normal: {

            //   }
            // }
          }
        ]
      });
    }
  }
};
</script>

<style>
.weatherBox {
  height: 100vh;
  width: 100vw;
  /* background-color: #53d2f9; */
  /* background-image: linear-gradient(#23ccff, #70a0f6); */
  background-image: url("https://moodsci.com/mimiproweb/img/126459153_0_final.png");
  overflow-y: auto;
}
.WeatherPlaBox {
  height: 50px;
  width: 100%;
  /* background-color: antiquewhite; */
  text-align: center;
  line-height: 50px;
  color: white;
}
.weatherinfoBox {
  height: 200px;
  width: 100%;
  /* background-color: aliceblue; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.weatherinfoBoxItem {
  height: 150px;
  width: 150px;
  /* background-color: antiquewhite; */
}
.weatherIconBox {
  height: 80px;
  width: 100%;
  /* background-color: #53d2f9; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.WeatherIcon {
  /* width: 50%; */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.TemBox {
  /* width: 50%; */
  height: 100%;
  text-align: center;
  line-height: 80px;
  color: white;
  font-size: 70px;
}
.weadesox {
  height: 50px;
  width: 100%;
  /* background-color: red; */
  text-align: center;
  font-size: 12px;
  /* line-height: px; */
  color: white;
}
.windBox {
  height: 80px;
  width: 70%;
  /* background-color: antiquewhite; */
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.windBoxItem {
  width: 20%;
  height: 100%;
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.ForeBox {
  height: 100px;
  width: 95%;
  border-bottom: 1px solid #adcaff;
  margin: auto;
  border-top: 1px solid #adcaff;
  margin-top: 20px;
  padding: 5px 10px;
  background-color: #a5a5a559;
  padding: 0 5px;
  border-radius: 5px;
}
.foreList {
  height: 100%;
  width: 100%;
  /* background-color: aliceblue; */
  display: flex;
  justify-content: space-between;
}
.foreListItem {
  height: 100%;
  width: 15%;
  /* border: 1px solid white; */
  font-size: 14px;
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.weaEchartBox {
  height: 150px;
  width: 95%;
  background-color: rgba(255, 255, 255, 0.479);
  margin: auto;
  margin-top: 20px;
  padding: 5px;
  border-radius: 5px;
  /* margin-top: 20px; */
}
#myChart2 {
  /* background-color: rgba(255, 255, 255, 0.479); */
}
.chooseWeatype {
  height: 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #42a0fd;
  align-items: center;
}
.theayBox {
  width: 100%;
  height: 200px;
  /* background-color: aliceblue; */
  margin-top: 20px;
  /* background-color: #64a9f5; */
  display: flex;
  justify-content: space-evenly;
}
.theayBoxItem {
  height: 100%;
  width: 48%;
  background-color: #a5a5a559;
  border-radius: 10px;
}
.theayBoxItem1 {
  height: 100%;
  width: 48%;
  /* background-color: #ffffff50; */
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.theayBoxChiItem {
  height: 49%;
  width: 100%;
  background-color: #a5a5a559;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  align-items: center;
}
.windInfoBox {
  /* height: 100%; */
  width: 50%;
  font-size: 20px;
  color: white;
}
.windInfoBox2 {
  /* height: 100%; */
  width: 50%;
  font-size: 15px;
  color: white;
}
.iconBox {
  width: 50%;
  /* height: 100%; */
  text-align: center;
}
.desListBox {
  height: 100%;
  width: 100%;
  /* background-color: #23ccff; */
  padding: 0 10px;
}
.desListItem {
  height: 25%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid white;
  /* background-color: #23ccff; */
}
</style>